import React from 'react';
import { Button, CircularProgress } from "@mui/material";
import RemoveIcon from '@mui/icons-material/Remove';
import { useGetSessionQuery, useUnwatchMutation } from '../services/api';
import { useDispatch } from 'react-redux';
import { toast } from '../features/snackbar/snackbarSlice';

export function UnwatchButton({ guid }: { guid?: string; }) {
  const [unwatch, { isLoading }] = useUnwatchMutation();
  const { data: session } = useGetSessionQuery(guid);
  const dispatch = useDispatch();

  if (!session?.watching) {
    return null;
  }
  return (
    <Button
      disabled={isLoading}
      fullWidth
      onClick={() => {
        unwatch(session!.guid)
          .then(() => {
            dispatch(
              toast({
                message: 'Session Successfully Removed from Watchlist',
                severity: 'success',
              })
            );
          });
      }}
      style={{
        marginTop: 10
      }}
      startIcon={<RemoveIcon />}
      variant='outlined'
    >{isLoading
      ? <CircularProgress
        size={25} />
      : 'Remove from Watchlist'}</Button>
  );
}
